module.exports = __webpack_public_path__ + "static/media/paypal.20e4baff.svg";